module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('link', {
    attrs: {
      "href": "../../screen.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../../extend-screen.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../../main.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "name": "construct",
      "action": "",
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectID"
    },
    domProps: {
      "value": _vm.$store.state.selectID
    }
  }), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "oNav",
    staticStyle: {
      "position": "fixed",
      "z-index": "1",
      "right": "25px",
      "top": "10px",
      "text-align": "right",
      "margin-bottom": "10px",
      "background-color": "#f5efe1"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px outset",
      "padding": "3px 3px 3px 3px"
    }
  }, [(_vm.$store.state.evaluation) ? [_vm._v("\n\t    " + _vm._s(_vm.$t('evaluation')) + "\n\t    "), _c('a', {
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "../../construct/priceToTestData.action",
      "target": "_blank"
    }
  }, [_vm._v("Data Check/Test/Up")])] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "link-left",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t('goBack')) + " ")]), _vm._v(" "), _c('a', {
    staticClass: "link-right",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.toSetup
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18n.toSetup)))]), _vm._v(" "), _c('a', {
    staticClass: "cart-put",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.toCart
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18n.toCart)))])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "z-index": "1",
      "right": "25px",
      "top": "45px",
      "text-align": "right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('errors' in _vm.$store.state.checkResult || 'warnings' in _vm.$store.state.checkResult),
      expression: "'errors' in $store.state.checkResult || 'warnings' in $store.state.checkResult"
    }],
    staticStyle: {
      "background": "white",
      "border": "5px double #ccc"
    },
    attrs: {
      "id": "errorBoxSwitch"
    }
  }, [_c('md-button', {
    staticStyle: {
      "margin": "0px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBox($event)
      }
    }
  }, [('errors' in _vm.$store.state.checkResult) ? _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "red",
      "text-transform": "none"
    }
  }, [_c('md-icon', {
    attrs: {
      "md-src": "../static/ic_report_problem_black_18px.svg"
    }
  }), _vm._v("\n\t      " + _vm._s(_vm.$t('errorsExist')))], 1) : _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#3673ac",
      "text-transform": "none"
    }
  }, [_c('md-icon', {
    attrs: {
      "md-src": "../static/ic_report_problem_black_18px.svg"
    }
  }), _vm._v("\n\t      " + _vm._s(_vm.$t('warningsExist')))], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('price' in _vm.$store.state.checkResult),
      expression: "'price' in $store.state.checkResult"
    }],
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "priceBox"
    }
  }, [_c('span', {
    staticStyle: {
      "background": "white",
      "border": "5px double #ccc",
      "padding": "3px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "100%",
      "font-weight": "bolder"
    }
  }, [_vm._v("\n\t        " + _vm._s(_vm.$t('totalPrice')) + "\n\t      "), ('en' == _vm.$i18n.locale) ? [_vm._v(_vm._s(this.currencyCode))] : _vm._e(), _vm._v(" \n\t    ")], 2), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "120%"
    }
  }, [_c('span', {
    attrs: {
      "id": "price"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.checkResult.price))]), _vm._v(" "), ('ja' == _vm.$i18n.locale) ? [_vm._v(" 円")] : _vm._e()], 2), _vm._v(" "), ('ja' == _vm.$i18n.locale) ? _c('span', {
    staticStyle: {
      "background": "white",
      "font-size": "80%"
    }
  }, [_vm._v("(税別)")]) : _vm._e()]), _vm._v(" "), _c('p')])]), _vm._v(" "), ('eight' == _vm.siteType) ? _c('span', {
    staticStyle: {
      "font-size": "70%"
    }
  }, [_vm._v("[カートに入れる]をクリックすると見積り/購入相談できます")]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "pkg",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.model) + " "), (_vm.old) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.$store.state.status) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.manager) ? _c('span', [_vm._v("   "), _c('a', {
    staticClass: "maintenance",
    attrs: {
      "href": _vm.updateTags,
      "target": "_blank"
    }
  }, [_vm._v("タグ登録")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.enableOptionInfoLink) ? _c('div', {
    staticStyle: {
      "float": "left",
      "text-align": "left",
      "padding-left": "30px",
      "font-size": "small"
    }
  }, [_c('a', {
    staticClass: "link-info",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "javascript:to_optioninfo('ToBaseCodeInfo.action');"
    },
    on: {
      "click": _vm.toBaseCodeInfo
    }
  }, [_vm._v("価格・スペック情報確認")])]) : _vm._e()]), _vm._v(" "), (_vm.isIntranet && (_vm.hippakuBody || _vm.hippakuStorage)) ? [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red",
      "font-size": "100%"
    }
  }, [_c('br'), _vm._v("\n\t  ★重要なお知らせ★（2021年12月15日更新）"), _c('br'), _vm._v("\n\t  半導体逼迫の影響により、下記製品は受注停止いたしました。"), _c('br'), _vm._v(" "), _c('ul', [(_vm.hippakuBody) ? [_c('li', [_vm._v("Express5800/T110j, T110j-S, GT110j本体")]), _vm._v(" "), _c('li', [_vm._v("Express5800/T110j-S(映像)本体")])] : _vm._e(), _vm._v(" "), (_vm.hippakuStorage) ? _c('li', [_vm._v("iStorage NS100Tj")]) : _vm._e()], 2), _vm._v("\n\t  代替構成など詳細は "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://one.nec.com/post/1346066"
    }
  }, [_vm._v("https://one.nec.com/post/1346066")]), _vm._v(" をご確認ください。\n\t")])] : _vm._e(), _vm._v(" "), _vm._l((_vm.children), function(c, index) {
    return [('selection' == c.nodeName.toLowerCase()) ? _c('selection', {
      attrs: {
        "el": c
      }
    }) : _c('simple-element', {
      attrs: {
        "el": c
      }
    })]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('' != _vm.systemError),
      expression: "'' != systemError"
    }]
  }, [_c('dl', {
    staticClass: "error"
  }, [_c('dt', [_vm._v("System Error")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.systemError))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "note",
    staticStyle: {
      "position": "fixed",
      "z-index": "2",
      "left": "59%",
      "right": "20px",
      "top": "120px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.errorBoxShow),
      expression: "$store.state.errorBoxShow"
    }],
    ref: "errorBox",
    staticClass: "error"
  }, [_c('dt'), _vm._v(" "), _c('dd', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n\t     \n\t    "), _c('md-button', {
    staticClass: "md-icon-button",
    staticStyle: {
      "width": "22px",
      "min-width": "22px",
      "height": "22px",
      "min-height": "22px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBox($event)
      }
    }
  }, [_c('md-icon', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "md-src": "../static/ic_close_black_18px.svg"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "errorList"
    }
  }, _vm._l((_vm.$store.state.checkResult.errors), function(info, key) {
    return _c('li', [_vm._v(_vm._s(key) + "\n\t      "), _vm._l((info), function(section) {
      return [(_vm.sectionExist(section)) ? _c('a', {
        staticClass: "section_link",
        staticStyle: {
          "text-decoration": "none",
          "border": "none",
          "color": "#3673ac"
        },
        attrs: {
          "href": '#' + section,
          "onmouseover": "this.style.color='#ff7f50'",
          "onmouseout": "this.style.color='#3673ac'"
        }
      }, [_c('img', {
        staticStyle: {
          "padding-bottom": "3px",
          "vertical-align": "bottom"
        },
        attrs: {
          "title": section + 'へ',
          "src": require("../../static/icon_flink.gif")
        }
      }), _vm._v("\n\t\t  " + _vm._s(section) + "\n\t\t")]) : _vm._e()]
    }), _vm._v(" "), _vm._l((info), function(section) {
      return [(!_vm.sectionExist(section)) ? [_vm._v("\n\t\t  " + _vm._s(section) + "\n\t\t")] : _vm._e()]
    })], 2)
  }))])])]), _vm._v(" "), _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.warningBoxShow),
      expression: "$store.state.warningBoxShow"
    }],
    ref: "warningBox",
    staticClass: "warning"
  }, [_c('dt', [_c('div', {
    staticStyle: {
      "float": "right",
      "_text-align": "right",
      "font-size": "120%"
    }
  }, [_vm._v("\n\t     \n\t    "), _c('md-button', {
    staticClass: "md-icon-button",
    staticStyle: {
      "width": "22px",
      "min-width": "22px",
      "height": "22px",
      "min-height": "22px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBox($event)
      }
    }
  }, [_c('md-icon', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "md-src": "../static/ic_close_black_18px.svg"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1), _vm._v("\n\t  " + _vm._s(_vm.$t('warnings')) + "\n\t")]), _vm._v(" "), _c('dd', [_c('ul', {
    attrs: {
      "id": "warningList"
    }
  }, _vm._l((_vm.$store.state.checkResult.warnings), function(info, key) {
    return _c('li', [_vm._v(_vm._s(key) + _vm._s(info))])
  }))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "note",
    staticStyle: {
      "padding": "7px",
      "border": "solid 1px",
      "position": "absolute",
      "z-index": "1",
      "left": "0px",
      "top": "0px",
      "background-color": "white",
      "display": "none"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    staticStyle: {
      "float": "right",
      "width": "22px",
      "min-width": "22px",
      "height": "22px",
      "min-height": "22px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeToc($event)
      }
    }
  }, [_c('md-icon', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "md-src": "../static/ic_close_black_18px.svg"
    }
  })], 1), _vm._v(" "), _vm._l((this.$store.state.section), function(sec) {
    return [_c('a', {
      staticStyle: {
        "color": "#3673ac"
      },
      attrs: {
        "href": '#' + sec,
        "onMouseOver": "this.style.borderBottom = 'none'"
      },
      on: {
        "click": _vm.closeToc
      }
    }, [_vm._v(_vm._s(sec))]), _c('br')]
  })], 2), _vm._v(" "), _c('md-dialog', {
    ref: "oldAlert"
  }, [_c('div', {
    staticClass: "warning"
  }, [_c('md-dialog-content', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "150%"
    }
  }, [_vm._v("\n\t旧モデルの詳細選択ページです。"), _c('br'), _vm._v("このページでは新規オプション等のメンテナンスを実施しておりません。\n      ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('oldAlert')
      }
    }
  }, [_vm._v("OK")])], 1)], 1)]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": _vm.$store.state.snackbar.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.$store.state.snackbar.message)))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "light-blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:",
      "onClick": "errorBoxToggle(); errorWindow = new ErrorWindow()"
    }
  }, [_c('span', {
    staticClass: "ui-icon ui-icon-extlink",
    staticStyle: {
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:",
      "onClick": "errorBoxToggle()"
    }
  }, [_c('span', {
    staticClass: "ui-icon ui-icon-close",
    staticStyle: {
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "warning_check_ok",
      "href": "javascript:",
      "onClick": "to_cart()"
    }
  }, [_c('span', {
    staticClass: "ui-icon ui-icon-check",
    staticStyle: {
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "dummy",
      "href": ""
    }
  }, [_c('span', {
    staticClass: "ui-icon ui-icon-check",
    staticStyle: {
      "float": "right"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0badcb4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mdf.vue
// module id = 450
// module chunks = 1